import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Wait for session check if not already done
    if (!authService.user()) {
        await authService.checkSession();
    }

    // Check if user is logged in AND is admin
    if (authService.user() && authService.isAdmin()) {
        return true;
    }

    return router.createUrlTree(['/login']);
};
